import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../constants";

/* ---------- Header stat tile (white-on-primary) ----------
 * Mirrors the "DRIVO NETWORK" banner tiles on Insights → Network: the label and
 * value use the same MUI Typography variants (caption / subtitle1) and the same
 * tile styles, so sizing stays in lockstep with that page. */

const useStyles = makeStyles({
  tile: { textAlign: "center" },
  tileLabel: { color: "rgba(255,255,255,0.45)", marginBottom: 2 },
  tileValue: { fontWeight: 700, color: "#fff" },
  track: { margin: "3px auto 0", height: 3, width: 72, borderRadius: 999, overflow: "hidden", background: "rgba(255,255,255,0.18)" },
  bar: { height: "100%", borderRadius: 999 },
});

export default function TopStat({ label, value, pct }) {
  const cls = useStyles();
  return (
    <div className={cls.tile}>
      <Typography variant="caption" component="div" className={cls.tileLabel}>{label}</Typography>
      <Typography variant="subtitle1" component="div" className={cls.tileValue}>{value}</Typography>
      {typeof pct === "number" && (
        <div className={cls.track}>
          <div className={cls.bar} style={{ width: `${pct}%`, background: pct >= 90 ? T.danger : pct >= 75 ? T.warningSolid : "rgba(255,255,255,0.8)" }} />
        </div>
      )}
    </div>
  );
}
